import { TeleTechnicianWorkApiClient } from "./generated";

export function createTeleTechnicianWorkApiClient() {
    var token = localStorage.getItem("accessToken");
    var apiClient = new TeleTechnicianWorkApiClient({
        BASE: process.env.REACT_APP_API_BASEURL,
        TOKEN: token ? token : undefined
    })
    return apiClient;
}